import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as moment from 'moment';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MaterialModule } from '../material.module';
//import { DragDropDirective } from './drag-drop.directive';
import { DualColumnFormComponent } from './dual-column-form/dual-column-form.component';
import { LineCalculationComponent } from './pricing-scheme/line-calculation.component';
import { SingleColumnFormComponent } from './single-column-form/single-column-form.component';

@NgModule({
  declarations: [
    SingleColumnFormComponent,
    DualColumnFormComponent,
    LineCalculationComponent,
    //DragDropDirective,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    FlexLayoutModule,
    NgxMatSelectSearchModule
  ],
  exports: [
    SingleColumnFormComponent,
    DualColumnFormComponent,
    LineCalculationComponent,
    //DragDropDirective,
  ]
})
export class UtilitiesModule {
}
